import { LabelWeight } from '../components/Weight/Label';

export const performancesColumns = [
  {
    label: 'Time in Holding (min)',
  },
  {
    label: 'Share (%)',
  },
  {
    Component: <LabelWeight label="Weight" metricBase="kg" />,
  },
];
